import React from 'react';

const SvgPro = props => (
    <svg width="1em" height="1em" viewBox="0 0 14 11" {...props}>
        <path d="M13.8281 3.87175C13.936 2.98663 12.7578 2.58345 12.3008 3.34908L11.1973 5.19776C10.9839 5.55521 10.4661 5.55521 10.2527 5.19776L7.85839 1.1867C7.53832 0.650515 6.76168 0.650517 6.44161 1.1867L4.04726 5.19776C3.83388 5.55521 3.31612 5.55521 3.10274 5.19776L1.9992 3.34908C1.54216 2.58345 0.363996 2.98663 0.47187 3.87175L1.19167 9.77778C1.19167 10.4528 1.59181 11 2.08542 11H12.2146C12.7082 11 13.1083 10.4528 13.1083 9.77778L13.8281 3.87175Z" fill="#F6C423"/>
    </svg>
);

export default SvgPro;
